export enum ProjectStatus {
  CLOSED = 1,
  DRAFT = 2,
  ACCEPTED = 3,
  AWAITING = 4,
}

export interface ProjectPublish {
  status: ProjectStatus;
}
